import { Container, LinearProgress } from "@mui/material";
import React, { useEffect, useState } from "react";

import OurCompany from "./OurCompany";
import OurFeatures from "./OurFeatures";
import WhyUs from "./WhyUs";
import { api_Routes } from "../../../api_Routes";
import { Helper } from "../../../tools/Helper";

const AboutUs = () => {
  const [Page, setPage] = useState({});
  const [sections, setSections] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const getPage = async () => {
      setIsLoading(true);
      const url = `${api_Routes.Pages.View}/about-us`;
      const { response } = await Helper.Get({
        url,
        hasToken: true,
      });
      if (response) {
        setPage(response);
        setSections(response.sections);
      }
      setIsLoading(false);
    };
    getPage();
  }, []);
  return (
    <Container
      sx={{
        marginBlock: "30px",
        "@media (min-width: 1200px)": {
          maxWidth: "1400px",
        },
      }}
    >
      {isLoading && <LinearProgress />}
      {sections?.map((sec, i) => (
        <div key={sec.id || i} style={{ marginTop: 24 }}>
          {sec.content?.heading === "Our Company" && <OurCompany sec={sec} />}
          {sec.content?.heading === "Why US" && <WhyUs sec={sec} />}
          {sec.content?.heading === "Our Features" && <OurFeatures sec={sec} />}
        </div>
      ))}
    </Container>
  );
};

export default AboutUs;
